var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoLandscape(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1",
    width: 818.31689,
    height: 340.35614,
    viewBox: "0 0 818.31687 340.35614",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-505.49221,-291.068)",
    id: "path36"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-676.40141,-303.85271)",
    id: "path38"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-659.27051,-263.69101)",
    id: "path40"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-381.22171,-418.25261)",
    id: "path54"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-383.34181,-426.19841)",
    id: "path56"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer-MC1",
    transform: "translate(-180.93748,-224.2048)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path35",
    d: "m 0,0 c -8.086,-16.448 -15.668,-17.086 -18.782,-17.086 -12.407,0 -13.679,15.434 -4.687,32.214 14.95,27.9 32.796,22.5 35.445,15.37 C 11.307,27.57 6.882,14 0,0 M 67.519,5.53 C 54.115,-7.594 38.39,-17.448 31.314,-15.614 c -13.121,3.4 -3.93,39.928 -2.873,44.16 -1.497,5.872 -10.432,17.887 -27.771,17.887 -12.923,0 -30.117,-9.409 -40.403,-28.233 -9.871,-18.064 -9.914,-38.51 -1.494,-46.931 15.351,-15.35 43.123,-4.557 53.748,20.897 1.242,-8.112 3.784,-18.658 14.937,-18.658 11.051,0 28.39,12.668 43.133,28.205 2.106,2.22 -0.849,5.995 -3.072,3.817",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,673.9896,405.61067)",
    clipPath: "url(#clipPath36)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path37",
    d: "m 0,0 c -7.554,-4.599 -17.121,-8.333 -27.995,-8.333 -9.359,0 -19.343,2.08 -25.773,4.855 -15.645,-32.579 -32.504,-45.703 -33.073,-45.703 -6.603,-0.972 -13.187,3.531 -17.226,15.535 -2.037,6.051 -19.058,56.299 -19.058,56.299 0,0 6.162,8.879 15.727,8.879 20.9,0 12.827,-18.482 12.085,-28.911 -0.976,-13.729 3.651,-33.784 10.177,-36.625 2.002,0 20.132,22.863 20.132,39.776 -8.254,18.485 -5.678,36.888 4.943,36.888 8.752,0 12.239,-9.416 12.239,-16.568 0,-6.236 -1.167,-15.131 -3.198,-22.46 2.814,-2.145 14.358,-7.11 24.155,-7.11 9.259,0 17.593,3.301 24.503,7.572 C 3.216,7.542 4.532,2.759 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,901.86853,388.5644)",
    clipPath: "url(#clipPath38)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path39",
    d: "m 0,0 c -3.224,5.136 3.206,15.401 15.326,22.661 2.551,-2.17 7.691,-6.5 8.947,-10.489 C 29.182,-3.411 4.627,-7.368 0,0 M 84.606,53.436 C 79.058,53.226 53.614,48.14 33.115,38.048 24.072,45.465 6.307,48.2 11.176,61.583 c 2.072,0 26.677,-1.543 26.677,11.773 0,0 -3.583,3.957 -13.281,3.957 -9.695,0 -29.596,-5.416 -29.596,-23.284 0,-14.483 8.957,-21.266 16.444,-27.961 C -1.234,18.421 -8.618,9.536 -8.618,1.305 c 0,-3.334 3.257,-12.798 21.089,-12.798 12.629,0 35.259,5.114 35.259,25.301 0,7.809 -6.536,16.01 -10.671,20.628 17.419,8.523 36.432,13.287 53.008,16.534 0,0 1.318,2.722 -5.461,2.466",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,879.02733,442.11333)",
    clipPath: "url(#clipPath40)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer-MC3",
    transform: "translate(-180.93748,-224.2048)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path41",
    d: "M 0,0 72.618,-125.783 H 217.86 L 290.483,0 Z",
    style: {
      fill: "#ffd47c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,180.93747,396.85027)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    d: "M 0,0 72.618,125.783 H 217.86 L 290.483,0 Z",
    style: {
      fill: "#fff2d9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,180.93747,396.85027)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path43",
    d: "m 0,0 h 72.62 72.623 L 72.62,-125.783 36.307,-62.89 Z",
    style: {
      fill: "#ffc74f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,374.5912,396.85027)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    d: "M 0,0 H 145.24 L 72.618,-125.783 Z",
    style: {
      fill: "#ffb500",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,180.93747,396.85027)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path45",
    d: "m 0,0 -36.31,62.893 -36.313,62.89 H 72.62 L 36.311,62.893 Z",
    style: {
      fill: "#ffeabe",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,374.59507,396.85027)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    d: "m 0,0 h -72.623 -72.617 l 72.617,125.783 z",
    style: {
      fill: "#ffa900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,374.5912,396.85027)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path47",
    d: "M 0,0 36.309,-62.892 H 108.93 L 145.242,0 Z",
    style: {
      fill: "#4bcacf",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,277.7656,396.85027)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48",
    d: "M 0,0 36.309,62.892 H 108.93 L 145.242,0 Z",
    style: {
      fill: "#afe5e7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,277.7656,396.85027)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path49",
    d: "M 0,0 H 36.31 72.622 L 36.31,-62.892 18.154,-31.444 Z",
    style: {
      fill: "#00b9c1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,374.5924,396.85027)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path50",
    d: "M 0,0 H 72.62 L 36.309,-62.892 Z",
    style: {
      fill: "#00a5ae",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,277.7656,396.85027)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path51",
    d: "M 0,0 -18.155,31.446 -36.311,62.892 H 36.31 L 18.155,31.446 Z",
    style: {
      fill: "#8ddade",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,374.5944,396.85027)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path52",
    d: "M 0,0 H -36.311 -72.62 l 36.309,62.892 z",
    style: {
      fill: "#00939f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,374.5924,396.85027)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer-MC4",
    transform: "translate(-180.93748,-224.2048)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path53",
    d: "M 0,0 H 2.051 C 3.003,0 3.736,0.172 4.25,0.517 4.764,0.861 5.021,1.378 5.021,2.068 5.021,2.45 4.95,2.773 4.808,3.036 4.666,3.298 4.469,3.512 4.217,3.676 3.965,3.84 3.659,3.96 3.298,4.037 2.937,4.113 2.538,4.151 2.1,4.151 H 0 Z M 0,-6.449 H -1.182 V 5.169 H 2.231 C 2.8,5.169 3.328,5.114 3.815,5.005 4.302,4.895 4.724,4.718 5.079,4.472 5.434,4.226 5.71,3.906 5.907,3.512 6.104,3.118 6.203,2.636 6.203,2.068 6.203,1.641 6.125,1.252 5.974,0.902 5.819,0.552 5.612,0.249 5.35,-0.009 5.087,-0.266 4.774,-0.471 4.414,-0.624 4.053,-0.777 3.659,-0.875 3.232,-0.919 l 3.397,-5.53 H 5.185 L 1.969,-1.018 H 0 Z",
    style: {
      fill: "#ffa900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,508.2956,236.0312)",
    clipPath: "url(#clipPath54)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path55",
    d: "m 0,0 c -4.735,0 -8.587,-3.852 -8.587,-8.586 0,-4.734 3.852,-8.586 8.587,-8.586 4.734,0 8.586,3.852 8.586,8.586 C 8.586,-3.852 4.734,0 0,0 m 0,-18.095 c -5.244,0 -9.51,4.266 -9.51,9.509 0,5.243 4.266,9.51 9.51,9.51 5.243,0 9.51,-4.267 9.51,-9.51 0,-5.243 -4.267,-9.509 -9.51,-9.509",
    style: {
      fill: "#ffa900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,511.1224,225.4368)",
    clipPath: "url(#clipPath56)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLandscape);
export default __webpack_public_path__ + "static/media/logo-landscape.e5ce1b3d9efae42f4316221fc2ff1fae.svg";
export { ForwardRef as ReactComponent };